
import { hideLaunchEditOnMobile } from '~commonInfra/utils/MobileHelper';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ILaunchWebAuthoringAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { editViewDraft } from '~src/views/actions/EditViewAction';


export const EditViewAction: IEntityAction<IContentInfo, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editView_action,
  isVisible: () => !hideLaunchEditOnMobile(),
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => {
    return editViewDraft(targetItems[0], 'ActionMenu_EditView');
  }
};
